module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_024.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_024.png
// module id = 2371
// module chunks = 5